import axios from 'axios';
import { PRODUCT_ENQUIRY } from '@/config/platformtype';

/**
 * 查询免费拿详情
 *
 * @param denominationId 	免费拿id
 */
export function getDetails(couponId) {
  return axios({
    url: `/mall/app/free_take/details/${couponId}`,
    method: 'get',
    params: {
      platform: PRODUCT_ENQUIRY,
    },
  });
}

/**
 * 查询产品可参与的免费拿
 *
 * @param {
 *  productId: 产品id
 * } params
 */
export function getList(params) {
  return axios({
    url: '/mall/app/free_take/list',
    method: 'get',
    params,
  });
}

/**
 * 参与免费拿
 *
 * @param data 面额id
 */
export function takePart(data) {
  return axios({
    url: '/mall/app/free_take/take_part',
    method: 'post',
    data,
  });
}

/**
 * 已获得的免费拿详情
 *
 * @param orderId 订单id
 */
export function gottenDetails(orderId) {
  return axios({
    url: `/mall/app/free_take/gotten/details/${orderId}`,
    method: 'get',
    params: {
      platform: PRODUCT_ENQUIRY,
    },
  });
}

/**
 * 完善免费拿订单收货信息
 */
export function complete(data) {
  return axios({
    url: `/mall/app/order/complete/${data.orderId}`,
    method: 'put',
    data,
  });
}
